// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/list/index.css
// module id = 446
// module chunks = 32